import React, { useEffect, useState } from 'react';
import { Button } from './ui';

const LOCAL_STORAGE_KEY = 'pwa-install-dismissed';

interface InstallPromptProps {
  deferredPrompt: BeforeInstallPromptEvent | null;
  setDeferredPrompt: (event: BeforeInstallPromptEvent | null) => void;
}

const InstallPrompt: React.FC<InstallPromptProps> = ({
  deferredPrompt,
  setDeferredPrompt,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (deferredPrompt && !localStorage.getItem(LOCAL_STORAGE_KEY)) {
      setOpen(true);
    }
  }, [deferredPrompt]);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    localStorage.setItem(LOCAL_STORAGE_KEY, outcome);
    setOpen(false);
    setDeferredPrompt(null);
  };

  const handleClose = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY, 'dismissed');
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 bg-card-bg text-text-primary px-4 py-3 rounded-lg shadow-lg flex items-center gap-3"
      role="status"
      aria-live="polite"
    >
      <span className="text-sm">Install Ground Rounds for a better experience</span>
      <Button onClick={handleInstall} className="text-sm px-3 py-1">
        Install
      </Button>
      <button onClick={handleClose} className="text-gray-400 hover:text-text-primary ml-1" aria-label="Dismiss">
        ✕
      </button>
    </div>
  );
};

export default InstallPrompt;
